/* Vault of Delights — bought-together + cart add-on rail */
(function () {
  'use strict';

  var MONEY_FMT;

  /* Derive the shop's exact money format from a Liquid-rendered sample
     (data-money-sample="{{ 123456 | money }}") so JS totals match the
     prices the theme prints, in every market and currency. */
  function buildFormatter(sample) {
    var m = String(sample).match(/^([^0-9]*)([0-9][0-9.,\s\u00a0']*[0-9]|[0-9])([^0-9]*)$/);
    if (!m) return null;
    var prefix = m[1];
    var body = m[2];
    var suffix = m[3];
    var dec = '';
    var decimals = 0;
    var tail = body.slice(-3);
    if (/^[.,][0-9]{2}$/.test(tail)) {
      dec = tail.charAt(0);
      decimals = 2;
      body = body.slice(0, -3);
    }
    var seps = body.replace(/[0-9]/g, '');
    var thou = seps.length ? seps.charAt(seps.length - 1) : '';
    return function (cents) {
      var negative = cents < 0;
      var value = Math.abs(cents);
      var whole = decimals === 2 ? Math.floor(value / 100) : Math.round(value / 100);
      var frac = decimals === 2 ? ('0' + (value % 100)).slice(-2) : null;
      var out = String(whole);
      if (thou) out = out.replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      if (frac !== null) out += dec + frac;
      return (negative ? '-' : '') + prefix + out + suffix;
    };
  }

  function fallbackFormat(cents) {
    var locale = document.documentElement.lang || 'en';
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function formatMoney(cents) {
    if (MONEY_FMT === undefined) {
      var el = document.querySelector('[data-money-sample]');
      MONEY_FMT = el ? buildFormatter(el.getAttribute('data-money-sample')) : null;
    }
    return MONEY_FMT ? MONEY_FMT(cents) : fallbackFormat(cents);
  }

  function cartHost() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function refreshCartCount() {
    return fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart.js'
      : '/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        return cart;
      })
      .catch(function () { return null; });
  }

  function addItems(items) {
    var host = cartHost();
    var body = { items: items };
    if (host && typeof host.getSectionsToRender === 'function') {
      body.sections = host.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) {
            throw new Error(data.description || data.message || window.cartStrings.error);
          }
          return data;
        });
      })
      .then(function (data) {
        var added = data.items && data.items.length ? data.items : [data];
        if (host && typeof host.renderContents === 'function' && data.sections) {
          try {
            host.renderContents({ key: added[added.length - 1].key, sections: data.sections });
          } catch (e) {
            refreshCartCount();
          }
        } else {
          refreshCartCount();
        }
        return data;
      });
  }

  /* ------------------------------------------------------------------ */

  class VodBoughtTogether extends HTMLElement {
    connectedCallback() {
      this.rows = Array.from(this.querySelectorAll('[data-vod-row]'));
      this.checks = Array.from(this.querySelectorAll('[data-vod-item]'));
      this.strip = this.querySelector('[data-vod-strip]');
      this.totalEl = this.querySelector('[data-vod-total]');
      this.addBtn = this.querySelector('[data-vod-add]');
      this.addLabel = this.querySelector('[data-vod-add-label]');
      this.statusEl = this.querySelector('[data-vod-status]');
      this.mainCheck = this.querySelector('[data-vod-main]');
      this.mainPriceEl = this.querySelector('[data-vod-main-price]');
      this.kitHint = this.querySelector('[data-vod-kit-hint]');
      this.baseLabel = this.addLabel ? this.addLabel.textContent.trim() : window.variantStrings.addToCart;

      var json = this.querySelector('[data-vod-main-variants]');
      this.variants = [];
      if (json) {
        try { this.variants = JSON.parse(json.textContent); } catch (e) { this.variants = []; }
      }

      this.buildStrip();
      this.checks.forEach(function (c) {
        c.addEventListener('change', this.update.bind(this));
      }, this);
      if (this.addBtn) this.addBtn.addEventListener('click', this.submit.bind(this));

      this.watchMainVariant();
      this.update();
    }

    buildStrip() {
      if (!this.strip) return;
      this.strip.innerHTML = '';
      this.rows.forEach(function (row, i) {
        var img = row.querySelector('[data-vod-thumb] img');
        if (!img) return;
        if (this.strip.children.length) {
          var plus = document.createElement('span');
          plus.className = 'vod-fbt__strip-plus';
          plus.textContent = '+';
          this.strip.appendChild(plus);
        }
        var cell = document.createElement('span');
        cell.className = 'vod-fbt__strip-item';
        var clone = document.createElement('img');
        clone.src = img.getAttribute('src');
        clone.alt = '';
        clone.loading = 'lazy';
        cell.appendChild(clone);
        cell.dataset.index = String(i);
        this.strip.appendChild(cell);
      }, this);
    }

    watchMainVariant() {
      var self = this;
      var input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      if (!input || !this.mainCheck) return;
      var sync = function () {
        var id = input.value;
        if (!id) return;
        self.mainCheck.dataset.variantId = id;
        var match = self.variants.filter(function (v) { return String(v.id) === String(id); })[0];
        if (match) {
          self.mainCheck.dataset.price = match.price;
          self.mainCheck.disabled = !match.available;
          if (!match.available) self.mainCheck.checked = false;
          if (self.mainPriceEl) self.mainPriceEl.textContent = formatMoney(match.price);
        }
        self.update();
      };
      new MutationObserver(sync).observe(input, { attributes: true, attributeFilter: ['value'] });
      input.addEventListener('change', sync);
      document.addEventListener('variant:change', sync);
      sync();
    }

    selected() {
      return this.checks.filter(function (c) { return c.checked && !c.disabled && c.dataset.variantId; });
    }

    update() {
      var chosen = this.selected();
      var total = chosen.reduce(function (sum, c) { return sum + parseInt(c.dataset.price, 10); }, 0);
      if (this.totalEl) this.totalEl.textContent = formatMoney(total);
      if (this.addBtn) this.addBtn.disabled = chosen.length === 0;
      if (this.addLabel) {
        this.addLabel.textContent = chosen.length > 1
          ? this.baseLabel + ' (' + chosen.length + ')'
          : this.baseLabel;
      }
      if (this.kitHint) {
        var hasKit = chosen.some(function (c) { return c.hasAttribute('data-vod-kit'); });
        var qualifies = chosen.length >= 3 && hasKit;
        this.kitHint.textContent = qualifies
          ? this.kitHint.dataset.hintActive
          : this.kitHint.dataset.hintDefault;
        if (qualifies) {
          this.kitHint.setAttribute('data-active', '');
        } else {
          this.kitHint.removeAttribute('data-active');
        }
      }
      if (this.strip) {
        Array.from(this.strip.querySelectorAll('.vod-fbt__strip-item')).forEach(function (cell) {
          var row = this.rows[parseInt(cell.dataset.index, 10)];
          var check = row && row.querySelector('[data-vod-item]');
          if (check && check.checked && !check.disabled) {
            cell.removeAttribute('data-off');
          } else {
            cell.setAttribute('data-off', '');
          }
        }, this);
      }
    }

    submit() {
      var self = this;
      var chosen = this.selected();
      if (!chosen.length) return;
      var items = chosen.map(function (c) {
        return { id: parseInt(c.dataset.variantId, 10), quantity: 1 };
      });
      this.addBtn.disabled = true;
      if (this.statusEl) this.statusEl.textContent = '';
      addItems(items)
        .then(function () {
          if (self.statusEl) {
            self.statusEl.textContent = self.dataset.addedMessage;
          }
        })
        .catch(function (err) {
          if (self.statusEl) self.statusEl.textContent = err.message;
        })
        .finally(function () {
          self.addBtn.disabled = false;
          self.update();
        });
    }
  }

  class VodCartRail extends HTMLElement {
    connectedCallback() {
      this.statusEl = this.querySelector('[data-vod-status]');
      this.addEventListener('click', this.onClick.bind(this));
    }

    onClick(event) {
      var btn = event.target.closest('[data-vod-rail-add]');
      if (!btn) return;
      event.preventDefault();
      var self = this;
      var original = btn.textContent;
      btn.disabled = true;
      btn.textContent = '...';
      addItems([{ id: parseInt(btn.dataset.variantId, 10), quantity: 1 }])
        .then(function () {
          if (self.statusEl) self.statusEl.textContent = self.dataset.addedMessage;
          window.location.reload();
        })
        .catch(function (err) {
          btn.disabled = false;
          btn.textContent = original;
          if (self.statusEl) self.statusEl.textContent = err.message;
        });
    }
  }

  if (!customElements.get('vod-bought-together')) {
    customElements.define('vod-bought-together', VodBoughtTogether);
  }
  if (!customElements.get('vod-cart-rail')) {
    customElements.define('vod-cart-rail', VodCartRail);
  }
})();
